// This file was auto-generated by Fern from our API Definition.
export var GatewayConnectionRef;
(function (GatewayConnectionRef) {
    GatewayConnectionRef.Provider = {
        Composio: "composio",
    };
})(GatewayConnectionRef || (GatewayConnectionRef = {}));
